/*
 * this function format a valid email
 * to its censored format
 * ex: johndoe@otrium.com -> j******@o*****.com
 * */
export const formatEmailAsCensored = (email: string): string => {
  const splitByAt = email.split("@");
  const username = splitByAt[0];
  const fullDomain = splitByAt[1];
  const splitByDot = email.split(".");
  const lastDomain = splitByDot[splitByDot.length - 1];

  return username
    .charAt(0)
    .concat("*".repeat(username.length - 1))
    .concat("@")
    .concat(fullDomain.charAt(0))
    .concat("*".repeat(fullDomain.length - lastDomain.length - 1 - 1))
    .concat(".")
    .concat(lastDomain);
};
